module.exports = __webpack_public_path__ + "website/img/kaifa.56d71a48.png";